import { sleep } from '@/plugins/xtpgui';
import userModel from './data/user';
import customersModel from './data/customers';
import contactsModel from './data/contacts';

///////////////////////////////////////////////////////////////////////
// ATENÇÃO: Esses serviços são fakes, desconsidere o uso em produção //
///////////////////////////////////////////////////////////////////////

let user = userModel, currentUser = null;
let customers = customersModel;
let contacts = contactsModel;

export const login = async(credential) => {
    // Mantido apenas como referência de uso.
    // const res = await http('docs').post('/api/login', credential);
    // if (res.status !== 200) {
    //     throw new Error(res.data.message);
    // }

    if (credential.username && credential.username.toUpperCase() === 'MASTER' && credential.password === '@xtpg') {
        window.sessionStorage.setItem('sid', user.token);
        await sleep(500);
        return user;
    }

    throw new Error('Desculpe! Sua credencial não foi autorizada.');
}

export const logout = async(credential) => {
    // Mantido apenas como referência de uso.
    // const res = await http('docs').get('/api/logout');
    // if (res.status === 200) {
    //     window.sessionStorage.removeItem('sid');
    // }

    window.sessionStorage.removeItem('sid');
}

export const checkToken = async() => {
    // Mantido apenas como referência de uso.
    // const res = await http('docs').get('/api/token');
    // if (res.status !== 200) {
    //     throw new Error(res.data.message);
    // }

    currentUser = { ...user };
    delete currentUser.token;
    return currentUser;
}

export const info = async() => {
    // Mantido apenas como referência de uso.
    // return http('docs').get('/api/version');

    return {
        data: { version: '1.0.0' }
    };
}

export const customerSvc = {
    async findAll() {
        // Mantido apenas como referência de uso.
        // return http('docs').get('/api/customers');

        return customers;
    }
};

export const contactSvc = {
    findAll() {
        // Mantido apenas como referência de uso.
        // return http('docs').get('/api/contacts');

        return contacts;
    }
};

export default {
    login,
    logout,
    checkToken,
    info,

    customerSvc,
    contactSvc,
}
